import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';
import { mixinRobotoBold } from '../../../../../styles';

export const AllContractsGraphStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .all-contracts-graph {
    height: 100%;
    max-width: 100%;
    padding: 0 16px 0 10px;
  }

  .no-data-message {
    width: 100%;
    margin: auto;
    flex-direction: column;
    align-items: center;
    font-size: 13px;
    color: var(--white-smoke);
  }

  .no-data-message .header {
    font-size: 15px;
    padding-bottom: 15px;
    color: var(--gray-lighter);
    font-weight: 500;
    ${mixinRobotoBold};
  }
`;
